import { gql, useMutation } from '@apollo/client';
import { useNavigate, useParams } from 'react-router';
import { UpsertTeamMutation } from '../../mutations';
import { MyTeamsQuery, TeamQuery } from '../../queries';
import { useQueryWithMsg } from '../../utils/hooks';
import TeamForm from './TeamForm';

const DeleteTeamMutation = gql`
  mutation DeleteTeam($input: DeleteTeamInput!) {
    deleteTeam(input: $input) {
      result
    }
  }
`;

const EditTeam = () => {
  const { teamId } = useParams();
  const { msg, data } = useQueryWithMsg(TeamQuery, {
    variables: { id: teamId },
  });
  const [submitMutation] = useMutation(UpsertTeamMutation, {
    refetchQueries: [
      {
        query: TeamQuery,
        variables: { id: teamId },
      },
    ],
  });

  const navigate = useNavigate();
  const [deleteMutation] = useMutation(DeleteTeamMutation, {
    refetchQueries: [
      {
        query: MyTeamsQuery,
      },
    ],
    onCompleted: ({ deleteTeam: { result } }) => {
      if (result) {
        navigate('/app');
      }
    },
    onError: (e) => {
      console.error(e);
    },
  });

  return (
    <TeamForm
      resource={data?.team}
      msg={msg}
      successMessage="Team updated successfully"
      submitButtonText="Save"
      submitMutation={submitMutation}
      showDelete
      deleteMutation={deleteMutation}
    />
  );
};

export default EditTeam;
